export const DASHBOARD_TAB = "dashboard";
export const DETAILS_TAB = "details";
export const ORDERS_TAB = "orders";
export const CONTACTS_TAB = "contacts";
export const DOCUMENTS_TAB = "documents";
export const ASSIGNMENTS_TAB = "assignments";
export const PHOTOS_TAB = "photos";
export const INSPECTIONS_TAB = "inspections";
export const ISSUES_TAB = "issues";

export const HOME_TABS = [
  { label: "Dashboard", value: DASHBOARD_TAB },
  { label: "Details", value: DETAILS_TAB },
  { label: "Orders", value: ORDERS_TAB },
  { label: "Inspections", value: INSPECTIONS_TAB },
  { label: "Issues", value: ISSUES_TAB },
];

export const MOBILE_HOME_TABS = [
  { label: "Details", value: DETAILS_TAB },
  { label: "Contacts", value: CONTACTS_TAB },
  { label: "Documents", value: DOCUMENTS_TAB },
  { label: "Assignments", value: ASSIGNMENTS_TAB },
  { label: "Orders", value: ORDERS_TAB },
  { label: "Photos", value: PHOTOS_TAB },
  { label: "Issues", value: ISSUES_TAB },
];
